/**
* DevExpress Dashboard (_chart-data-controller.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { localizationId } from '../_localization-ids';
import { localizer } from '../_localizer';
import { chartDataControllerProto } from './_chart-data-controller-proto';
export class chartDataController extends chartDataControllerProto {
    getArgumentBindingValue(argumentPoint, pointIndex) {
        if (this.isQualitativeArgument() || this.isDiscreteArgument()) {
            if (argumentPoint.getParent() != null) {
                return pointIndex.toString();
            }
            else {
                return localizer.getString(localizationId.ChartTotalValue);
            }
        }
        return argumentPoint.getValue();
    }
}
